module.exports = "https://de18y2hs3hlxs.cloudfront.net/04bbf00c-82ab-4e06-8439-4302b170a242/images/notepad-2.png?93936d7ca0aada75a2e9c11d9bd6e63d";